import PlacesUpdate from "./PlacesUpdate";

export default PlacesUpdate;
